import React, { useCallback, useState } from "react";
import ViewerEvents from "events/ViewerEvents";
import LayerProperties from "./LayerProperties";
import { Scrollbars } from "react-custom-scrollbars";
import FolderTree from "./FolderTree";
import { arrayEqualValues } from "services/UtilsService";
import { handleLayerEvent, handleLayers } from "actions/ViewerTools";
import LayersActions from "actions/LayersActions";
import { getGradientImage } from "actions/ViewerTools";
import {  useDispatch } from 'react-redux';
import { setData } from "store/main/viewerHistory";

type ILayersContainer = {
    currentProject: any;
    newScene: boolean;
    view: any;
    move?: boolean;
    selectedLayers: any;
    toggleSelectedLayers: (layer: any) => void;
    setSelectedLayers: (layer: any) => void;
    updateParent: () => void;
    addObjects: (source?: string) => void;
};

export default function LayersContainer(props: ILayersContainer) {
    const { view, selectedLayers, move, updateParent, setSelectedLayers } = props;
    const [layerId, setLayerId] = useState("");
    const [update, setUpdate] = useState(false);
    const [order, setOrder] = useState({ type: 4, reverse: false });
    const [filters, setFilters] = useState([]);
    const { layers:_layers, inputs } = ViewerEvents;
    const [layers, setLayers] = useState(_layers);
    const dispatch = useDispatch();

    const currentLayers = Object.values(layers);
    //console.log("currentLayers:", currentLayers);
    var filteredLayers = LayersActions.applyOrder(currentLayers, order.type, order.reverse);
    filteredLayers = LayersActions.applyFilters(filteredLayers, filters);
    //console.log('filteredLayers:', filteredLayers);

    var folders = LayersActions.folders;
    const foldersTree = LayersActions.constructTree(filteredLayers, folders);
    //console.log('foldersTree:', foldersTree);
    var onMouseMove = (event: any) => {
        if (event.shiftKey) {
            LayersActions.multipleSelection = true;
        } else {
            LayersActions.multipleSelection = false;
        }
    };


    React.useEffect(() => {
        const updateLayers = (data: any)  => {
            setLayers(data.layers)
        }
        ViewerEvents.on("onViewSave", updateLayers);

        return () => {
            ViewerEvents.removeEventListener("onViewSave", updateLayers);
        };
    }, []);


    React.useEffect(() => {
        setLayers(ViewerEvents.layers);
    }, [ViewerEvents.layers])
    
    React.useEffect(() => {
        const handleLayersOrder = (evt: any) => {
            console.log("layersFilter:", evt);
            LayersActions.needsUpdate = true;
            setOrder({ ...evt });
        };
        const addLayersFilters = (evt: any) => {
            LayersActions.needsUpdate = true;
            const currentFilters: any = [...filters];
            currentFilters.push({ ...evt });
            setFilters(currentFilters);
        };
        const updateLayersFilters = (filters: any) => {
            LayersActions.needsUpdate = true;
            setFilters(filters);
        };
        const updateTree = (_layers: any[]) => {
            const layers = _layers.reduce((layers: any, layer: any) => ({
                ...layers,
                ...(layer ? { [layer.ID]: layer } : {})
            }), {})
            setUpdate((prevUpdate) => !prevUpdate);
            dispatch(setData(JSON.parse(JSON.stringify({ layers }))));
        };
        document.addEventListener("mousemove", onMouseMove);
        LayersActions.on("changeLayersOrder", handleLayersOrder);
        LayersActions.on("addLayersFilters", addLayersFilters);
        LayersActions.on("updateTree", updateTree);
        LayersActions.on("updateLayersFilters", updateLayersFilters);
        return () => {
            document.removeEventListener("mousemove", onMouseMove);
            LayersActions.removeEventListener("changeLayersOrder", handleLayersOrder);
            LayersActions.removeEventListener("addLayersFilters", addLayersFilters);
            LayersActions.removeEventListener("updateTree", updateTree);
            LayersActions.removeEventListener("updateLayersFilters", updateLayersFilters);
        };
    }, [filters]);

    //console.log('LayersContainer.selectedLayers:', selectedLayers);
    let orderObjects: any = Object.keys(layers);
    let savedObjects: any = view.entity_container.trim().split(" ");
    var foldersId = folders.map((entity: any) => {
        if (entity.view_ref === view.ID) {
            return entity.ID;
        }
        return undefined;
    });
    foldersId = foldersId.filter((element: any) => {
        return element !== undefined;
    });
    foldersId.forEach((id: string) => {
        var idx = savedObjects.findIndex((element: any) => element === id);
        if (idx > -1) {
            savedObjects.splice(idx, 1);
        }
    });
    //console.log('currentTree', foldersTree);

    //console.log(orderObjects, savedObjects);
    //console.log("isEqual:", arrayEqualValues(orderObjects, savedObjects));
    if (arrayEqualValues(orderObjects, savedObjects)) {
        orderObjects = savedObjects;
    }

    if (Object.keys(layers).length > orderObjects.length) {
        Object.keys(layers).forEach((id: string) => {
            if (orderObjects.indexOf(id) === -1) {
                orderObjects.push(id);
            }
        });
    }

    const handleClose = () => {
        setSelectedLayers([]);
        setLayerId("");
    };

    const toggleVisibility = (visible: boolean, index?: string) => {
        if (!index) {
            index = layerId;
        }
        var currentLayer: any = Object.values(layers).find((layer: any) => layer.ID === index);
        if (currentLayer) {
            if (currentLayer.layer_visible) {
                currentLayer["layer_visible"] = visible ? "1" : "0";
            } else {
                currentLayer["layer_visible"] = "0";
            }
            handleLayerEvent("toggleVisibility", null, currentLayer);
            setUpdate(!update);
        }
    };

    const setTransparency = (value: number, index?: string) => {
        if (!index) {
            index = layerId;
        }
        const opacity = value / 100.0;
        LayersActions.setTransparency(opacity, index);
    };

    const deleteLayer = (layer: any) => {
        console.log("layer", layer);
        handleLayerEvent("deleteLayer", null, layer);
        var object = layers;
        delete layers[layer.ID];
        handleLayers({ ...object });
        handleClose();
        LayersActions.needsUpdate = true;
        LayersActions.emit("updateTree", layers);
        updateParent();
    };
    const handleDragEnter = (e: any) => {
        e.preventDefault();
    };
    const handleDragLeave = (e: any) => {
        e.preventDefault();
    };
    const handleDragOver = (e: any) => {
        e.preventDefault();
    };
    const handleDrop = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        LayersActions.emit("changeLayersOrder", {
            type: 4,
            reverse: false,
        });
        if (LayersActions.draggedFolder !== "") {
            LayersActions.dropFolder(LayersActions.draggedFolder, "0", () => {
                updateParent();
            });
        } else {
            LayersActions.moveLayerToFolder(LayersActions.draggedLayerId, "0", () => {
                updateParent();
            });
        }
    };
    /** Handle closing of layersProperties and Filter Menu */
    const handleClick = useCallback(
        (e: any) => {
            if (
                e.target.tagName === "DIV" &&
                !e.target.id.includes("layerContainer-") &&
                !LayersActions.multipleSelection
            ) {
                setSelectedLayers([]);
                LayersActions.startLayerSelect = null;
                LayersActions.emit("closeFilterMenu", null);
            }
        },
        [setSelectedLayers]
    );

    return (
        <div
            draggable={false}
            onDragOver={handleDragOver}
            onDrag={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <Scrollbars
                autoHide
                autoHideTimeout={10}
                autoHideDuration={10}
                style={{
                    width: "100%",
                    overflowX: "hidden",
                    height: "calc(100vh - 149px)",
                }}
                onClick={handleClick}
            >
                <FolderTree
                    {...props}
                    foldersTree={foldersTree}
                    setTransparency={setTransparency}
                    toggleVisibility={toggleVisibility}
                    setLayerId={setLayerId}
                />
            </Scrollbars>
            {selectedLayers.length > 0 && !move ? (
                <LayerProperties
                    handleClose={handleClose}
                    toggleVisibilty={toggleVisibility}
                    setTransparency={setTransparency}
                    deleteLayer={deleteLayer}
                    getGradientImage={getGradientImage}
                    inputs={inputs}
                    {...props}
                />
            ) : (
                ""
            )}
        </div>
    );
}
